if (!customElements.get('kivo-home-fit-guide')) {
  customElements.define(
    'kivo-home-fit-guide',
    class KivoHomeFitGuide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.currentStep = 0;
        this.stepPanels = Array.from(this.querySelectorAll('[data-kivo-home-05-step-panel]'));
        this.stepButtons = Array.from(this.querySelectorAll('[data-kivo-home-05-step-button]'));
        this.prevButton = this.querySelector('[data-kivo-home-05-prev]');
        this.nextButton = this.querySelector('[data-kivo-home-05-next]');
        this.swatchButtons = Array.from(this.querySelectorAll('[data-kivo-home-05-swatch]'));
        this.variantInput = this.querySelector('[data-kivo-home-05-variant-input]');
        this.addButton = this.querySelector('[data-kivo-home-05-add-button]');
        this.videoOpenButton = this.querySelector('[data-kivo-home-05-video-open]');
        this.videoModal = this.querySelector('[data-kivo-home-05-video-modal]');
        this.videoDialog = this.querySelector('[data-kivo-home-05-video-dialog]');
        this.videoFrame = this.querySelector('[data-kivo-home-05-video-frame]');
        this.videoTemplate = this.querySelector('[data-kivo-home-05-video-template]');
        this.videoCloseButtons = Array.from(this.querySelectorAll('[data-kivo-home-05-video-close]'));
        this.handleVideoKeyup = this.handleVideoKeyup.bind(this);

        this.stepButtons.forEach((button) => {
          button.addEventListener('click', () => this.setStep(Number(button.getAttribute('data-kivo-home-05-step-button'))));
        });

        this.prevButton?.addEventListener('click', () => this.setStep(this.currentStep - 1));
        this.nextButton?.addEventListener('click', () => this.setStep(this.currentStep + 1));

        this.swatchButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectSwatch(button));
        });

        const activeSwatch = this.swatchButtons.find((button) => button.classList.contains('is-active'));
        if (activeSwatch) this.selectSwatch(activeSwatch);

        this.videoOpenButton?.addEventListener('click', (event) => this.openVideoModal(event));

        if (this.videoModal) {
          this.videoCloseButtons.forEach((button) => {
            button.addEventListener('click', () => this.closeVideoModal());
          });

          if (this.videoModal.parentElement !== document.body) {
            document.body.appendChild(this.videoModal);
          }
        }
      }

      disconnectedCallback() {
        this.closeVideoModal(false);
        this.videoModal?.remove();
      }

      setStep(index) {
        if (!this.stepPanels.length) return;

        const nextIndex = (index + this.stepPanels.length) % this.stepPanels.length;
        this.currentStep = nextIndex;

        this.stepPanels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === nextIndex;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        this.stepButtons.forEach((button) => {
          const isActive = Number(button.getAttribute('data-kivo-home-05-step-button')) === nextIndex;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      selectSwatch(activeButton) {
        this.swatchButtons.forEach((button) => {
          const isActive = button === activeButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (!this.addButton || !activeButton.dataset.variantAvailable) return;

        const isAvailable = activeButton.dataset.variantAvailable === 'true';

        if (this.variantInput && activeButton.dataset.variantId) {
          this.variantInput.value = activeButton.dataset.variantId;
          this.variantInput.toggleAttribute('disabled', !isAvailable);
        }

        this.addButton.toggleAttribute('disabled', !isAvailable);
        this.addButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');

        this.addButton.querySelectorAll('[data-kivo-home-05-add-label]').forEach((label) => {
          label.textContent = isAvailable ? label.dataset.availableLabel : this.addButton.dataset.soldOutLabel;
        });
      }

      openVideoModal(event) {
        event.preventDefault();

        if (!this.videoModal || !this.videoDialog || !this.videoFrame || !this.videoTemplate) return;

        this.openedVideoButton = event.currentTarget;
        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();

        this.loadVideoContent();
        this.videoModal.hidden = false;
        this.videoModal.classList.add('is-open');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keyup', this.handleVideoKeyup);

        const closeButton = this.videoModal.querySelector('[data-kivo-home-05-video-close]:not([aria-hidden])');

        if (typeof trapFocus === 'function') {
          trapFocus(this.videoModal, closeButton || this.videoDialog);
        } else {
          (closeButton || this.videoDialog).focus();
        }
      }

      closeVideoModal(restoreFocus = true) {
        if (!this.videoModal || this.videoModal.hidden) return;

        this.videoModal.hidden = true;
        this.videoModal.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keyup', this.handleVideoKeyup);

        if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
        this.clearVideoContent();

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(restoreFocus ? this.openedVideoButton : null);
        } else if (restoreFocus) {
          this.openedVideoButton?.focus();
        }
      }

      handleVideoKeyup(event) {
        if (event.code.toUpperCase() === 'ESCAPE') this.closeVideoModal();
      }

      loadVideoContent() {
        this.clearVideoContent();
        this.videoFrame.appendChild(this.videoTemplate.content.cloneNode(true));
      }

      clearVideoContent() {
        if (!this.videoFrame) return;

        this.videoFrame.querySelectorAll('iframe').forEach((iframe) => {
          iframe.src = '';
        });

        while (this.videoFrame.firstChild) {
          this.videoFrame.removeChild(this.videoFrame.firstChild);
        }
      }
    }
  );
}
